import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import { BuyerRefundRequestModal } from 'v2/components/Shared/RefundReason';
import { redirectUserToNewRefundService } from 'v2/helpers/redirectUserToNewRefundService';
import { EPaymentMethod, type IRefundRequest, type ShoppingDelivery } from 'v2/interfaces/shopping';
import newRefundService from 'v2/services/new-refund-service';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

import type { NewRefundServicePermission } from 'v2/services/new-refund-service';

const RefundActions = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const [user] = useObservable<NewRefundServicePermission>(
    () => newRefundService.getPermissionToNewRefundServiceByInvoiceId(delivery.invoice_id.toString()),
    []
  );
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [refundRequest] = useObservable<IRefundRequest>(() => refundRequestFactory.buyerFindRefundByInvoiceId(delivery.invoice_id), []);

  React.useEffect(() => {
    if (refundRequest !== null) {
      setLoading(false);
    }
  }, [refundRequest]);

  const openRefundRequestModal = () => {
    setOpen(true);
  };

  const closeRefundRequestModal = () => {
    setOpen(false);
  };

  const onRefundRequestMade = () => {
    setOpen(false);
  };

  const canShowRefundRequestButton = refundRequest && !refundRequest.exist && delivery?.product.valid_to_refund_request;

  const hasPermissionToUseNewRefundService = user && user.success && user.data.producer_can_access;

  if (loading) {
    return (
      <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
        <CircularProgress size={20} />
      </Grid>
    );
  }

  if (refundRequest.exist && hasPermissionToUseNewRefundService) {
    return (
      <Grid item xs={12}>
        <Button color='primary' onClick={() => redirectUserToNewRefundService(delivery.invoice_id.toString(), 'tracking')} fullWidth>
          Acompanhar Reembolso
        </Button>
      </Grid>
    );
  }

  if (delivery.product.type === 'Ticket' && !canShowRefundRequestButton && !hasPermissionToUseNewRefundService) {
    return (
      <Grid item xs={12}>
        <Tooltip title='Poxa! O prazo para solicitar reembolso é de até 7 dias após a compra ou no máximo 48 horas antes do evento. Para solicitar o reembolso, por gentileza, entre em contato diretamente com o produtor do evento.'>
          <span>
            <Button color='primary' style={{ background: '#dc3f53', color: '#ffffff', opacity: '0.7' }} disabled fullWidth>
              Solicitar Reembolso
            </Button>
          </span>
        </Tooltip>
      </Grid>
    );
  }

  if (delivery.payment_method.id == EPaymentMethod.BOLETO_PARCELADO && !canShowRefundRequestButton && !hasPermissionToUseNewRefundService) {
    return (
      <Grid item xs={12}>
        <Tooltip title='Não é possível reembolsar faturas de Boleto Parcelado TMB'>
          <span>
            <Button color='primary' style={{ background: '#dc3f53', color: '#ffffff', opacity: '0.7' }} disabled fullWidth>
              Solicitar Reembolso
            </Button>
          </span>
        </Tooltip>
      </Grid>
    );
  }

  if (!canShowRefundRequestButton) return null;

  return (
    <>
      <Grid item xs={12}>
        <Button
          color='primary'
          style={{ background: '#dc3f53', color: '#ffffff' }}
          onClick={
            hasPermissionToUseNewRefundService
              ? () => redirectUserToNewRefundService(delivery.invoice_id.toString(), 'request')
              : openRefundRequestModal
          }
          fullWidth
        >
          Solicitar Reembolso
        </Button>
      </Grid>
      <BuyerRefundRequestModal open={open} invoiceId={delivery.invoice_id} onClose={closeRefundRequestModal} onFinish={onRefundRequestMade} />
    </>
  );
};

export default RefundActions;
